export default __webpack_public_path__ + "static/media/HTML_JS_CSS.021dc0f1.webp";